<template>
  <div class="Warp">
      <van-cell-group>
		<van-divider content-position="center" style="margin-top:0;padding-top: 0.5rem;">基本信息</van-divider>
        <van-cell title="用户昵称" :value="list.cid?list.cid:'昵称'" />
        <van-cell title="点餐订单编号" :value="list.order_no" />
        <van-cell title="支付订单号" :value="list.out_trade_no" />
        <van-cell title="支付金额" :value="'￥'+list.money" />
        <van-cell title="取餐号" :value="list.order_status == 0||list.order_status == -1 ? '无' : list.take_food_no" />
		<van-cell v-if="list.need_delivery==0" title="用餐类型" :value="list.type == 1 ? '堂食' : '打包'" />
		<van-cell v-if="list.need_delivery==1" title="用餐类型" value="外卖" />
		<van-cell v-if="list.need_delivery==1" title="配送费" :value="'￥'+list.delivery_money" />
		<van-cell v-if="list.need_delivery==1" title="配送信息">
			<div>{{list.detail}}</div>
			<div>{{list.name}}</div>
			<div>{{list.tel}}</div>
		</van-cell>
		
        <van-cell title="打包费" v-if="list.type == 2" :value="'￥'+list.pack_price" />
		<van-cell title="订单状态" v-if="list.order_status==-1" value="已取消" />
		<van-cell title="订单状态" v-else :value="['支付中','已支付','撤销支付','退款'][list.order_status]" />
		<van-cell title="订单备注" :value="list.remark==''?'无备注':list.remark" />
        <van-cell title="添加时间" :value="list.add_time" />
    <van-divider content-position="center">菜品信息</van-divider>
        <div class="food" v-for="item in list.food" :key="item.food_id">
          <div class="img">
            <img :src="baseURL + item.picture" />
          </div>
          <div class="title">
            <p class="name">{{item.name}}</p>
            <p class="specs">{{item.specs}}</p>
            <p class="num">x {{item.num}}</p>
          </div>
          <div class="price">
            <span>￥ {{item.price}}</span>
          </div>
        </div>
		<van-divider content-position="center">支付信息</van-divider>
        <van-cell title="支付订单号" :value="list.pay.out_trade_no" />
        <van-cell title="商户名称" :value="list.merchant_name" />
        <van-cell title="门店名称" :value="list.store_name" />
        <!-- <van-cell title="商户店名" :value="list.pay.trans_subject" /> -->
        <van-cell title="支付发起类型" :value="list.pay.trans_type" />
        <van-cell title="支付发起时间" :value="list.pay.trans_time" />
        <van-cell title="支付完成时间" :value="list.pay.trans_oktime" />
		<van-cell title="支付状态" v-if="list.pay.trans_status==-1" value="已取消" />
        <van-cell title="支付状态" v-else :value="['支付中','支付成功','撤销支付','退款'][list.pay.trans_status]" />
        <van-cell title="支付金额" :value="'￥'+list.pay.total_fee" />
      </van-cell-group>
    </div>
</template>
<script>
import Config from "@/config";
export default {
  data() {
    return {
      page: 1,
      limit: 10,
      list: {},
      baseURL:Config.baseURL,
      loading: false,
      refreshLoading: false,
      finished: false,
    };
  },
  mounted() {
	this.id=this.$route.query.id;
    this.getOrderDetails();
  },
  methods: {
    getOrderDetails() {
        var that = this;
        // var salesmanInfo = VueCookie.get("salesmanInfo");
        this.$http.post('/wechat/api.order/getOrder', {id:this.id}).then(response => {
            this.list = response.body.data;
			console.log('2222222222',this.list)
			// console.log('11111111',response)
        });
    },
    onRefresh() {
      this.page = 1;
      this.list = {};
      this.finished = false;
      this.getOrderDetails();
    },
    uploader() {
      this.page++;
      this.getOrderDetails();
    },
  },
};
</script>
<style lang="less" scoped>
.van_grid_item {
  color: #646566;
  font-size: 0.32rem;
  line-height: 1.5;
  word-break: break-all;
}
.food {
  margin: 0.14rem 0.42667rem;
  font-size: 0.4rem;
  display: flex;
}
.food p {
  padding: 0;
  margin: 0;
}
.food img {
  width: 2rem;
  height: 100%;
  border-radius: 0.1rem;
}
.food .title {
  flex: 1;
  margin-left: 0.2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.food .title .num,.food .title .specs {
  font-size: 0.3rem;
  color: #999;
}
</style>